module.exports = __webpack_public_path__ + "static/media/RP-86.dd212ffd.pdf";